module.exports = __webpack_public_path__ + "static/forms-recipients-do-895613a096b208d34e827a0c54aef3f2.png";